module.exports = __webpack_public_path__ + "img/DSC_9079.26befb67.jpg";